import StoryHeadline from './StoryHeadline';
import './story-headline.scss';

export default StoryHeadline;
